import * as Cookie from 'js-cookie';

class CaptivateConfig
{
	logoVersion = 1;
	logo;

	colorClassess = [
		'captivate-black',
		'captivate-blue',
		'captivate-red',
		'captivate-green',
		'captivate-yellow'
	];

	colorClass;

	constructor()
	{
		// rotate the logo colors
		// starts randomly but then each subsequent visit ensures a different logo color
		let totalLogos = 5;
		let n = 'captivate-logo-version';
		if (Cookie.get(n))
		{
			let i = parseInt(Cookie.get(n), 10);
			console.log(i);
			i = ((i + 1) % totalLogos) + 1;

			this.logoVersion = i;
		}
		else
		{
			this.logoVersion = Math.floor((Math.random() * 5) + 1);
		}

		Cookie.set(n, this.logoVersion);

		this.logo = 'captivate_hero_logo_' + this.logoVersion + '.png';
		this.colorClass = this.colorClassess[this.logoVersion - 1];
	}
}

export default CaptivateConfig;




// WEBPACK FOOTER //
// ./src/CaptivateConfig.js